var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrapper"},[_c('img',{staticClass:"dh-img",attrs:{"src":_vm.emptyUrl,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('PCProduct.empty')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }